export default __webpack_public_path__ + "images/GB.acfc496.png";